
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions",
      function () {
        return require("private-next-pages/exhibitions/index.tsx");
      }
    ]);
  